<template>
  <Dialog v-model:visible="showDialog" :modal="true" :header="$t('crm.templatesetup.leadsourcemaster.creation')"
    :breakpoints="{
      '1980px': '30vw',
      '1440px': '40vw',
      '960px': '75vw',
      '640px': '90vw',
    }" :style="{ width: '40vw' }" @after-hide="IsClear">
    <b-container>
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <b-col sm="12">
            <div class="field">
              <TextFields :id="$t('crm.templatesetup.leadsourcemaster.code')"
                :name="$t('crm.templatesetup.leadsourcemaster.code')" :disabled="true"
                :label="$t('crm.templatesetup.leadsourcemaster.code')" :rules="{ required: true }" v-model="isForm.Code"
                placeholder=" " />
            </div>
          </b-col>
          <b-col sm="12">
            <div class="field">
              <TextFields :id="$t('crm.templatesetup.leadsourcemaster.name')"
                :name="$t('crm.templatesetup.leadsourcemaster.name')"
                :label="$t('crm.templatesetup.leadsourcemaster.name')" :required-icon="true" :rules="{ required: true }"
                v-model="isForm.Name" placeholder=" " />
            </div>
          </b-col>
          <b-col sm="12">
            <div class="field">
              <Textarea :id="$t('crm.templatesetup.leadsourcemaster.desc')"
                :name="$t('crm.templatesetup.leadsourcemaster.desc')"
                :label="$t('crm.templatesetup.leadsourcemaster.desc')" :rules="{ required: false }"
                v-model="isForm.Description" placeholder=" " />
            </div>
          </b-col>
        </b-row>
        <Footer @cancel="(showDialog = false), IsClear()" :label="label" />
      </b-form>
    </b-container>
  </Dialog>
  <CreateSuccessully :visible="successPop" @ok="closetrigger()" />
  <EditConfirmation :editModel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <UpdatedSuccessfully :visible="updatePop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyExistPop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import TextFields from "../../../../../components/FormComponents/TextInput.vue";
import NumberField from "../../../../../components/FormComponents/InputNumber.vue";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import LeadSourceService from "../../../service/leadSource";
import AlreadyExist from "../../../../../components/FormComponents/AlreadyExist.vue";
import commonService from "../../../service/commonService";
import { useHotkey } from "v-hotkey3";
import moment from "moment";

export default defineComponent({
  props: {
    showDialog: {
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      required: false,
    },
    OperationID: {
      type: Object,
      default: {},
    },
  },
  components: {
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    Footer,
    TextFields,
    Textarea,
    NumberField,
    AlreadyExist,
  },
  setup(props, { emit }) {
    debugger;
    const successPop = ref(false);
    const updatePop = ref(false);
    const alreadyExistPop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const loading = ref(false);
    const { handleSubmit, errors } = useForm();
    const showDialog = ref();
    const model: any = ref(props.selectedItem);
    const label = ref(t('btn.save'));
    let localstoragedata = ref();
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);

    localstoragedata.value = localStorage.getItem("UsersData");
    localstoragedata.value = JSON.parse(localstoragedata.value);
    onMounted(() => {
      debugger;
    });
    const isForm = ref({
      CreatedAt: "2023-07-14T07:10:35.851Z",
      ModifiedAt: "2023-07-14T07:10:35.851Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      Id: 0,
      Code: "",
      Name: "",
      Description: "",
      ClientId: 0,
      CreatedDate: "2023-07-14T07:10:35.851Z",
      UpdatedBy: 0,
      UpdatedDate: "2023-07-14T07:10:35.851Z",
      IsDeleted: false,
      BranchId: ref(0),
      EntityId: 0,
      EntityOperationId: 0,
    });
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      emit("loadershow");
      try {
        let result: any;
        let msg = "";
        isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.ClientId = localstoragedata.value.OrganizationId;
        isForm.value.BranchId = localstoragedata.value.BranchId;
        isForm.value.EntityId = Entitydata.value.EntityId;


        // alert(JSON.stringify(localstoragedata.value.OrganizationId))
        if (isForm.value.Id != 0) {
          isForm.value.CreatedDate = "2023-02-10T05:35:01.084Z";
          isForm.value.UpdatedDate = "2023-02-10T05:35:01.084Z";
          isForm.value.EntityOperationId = props.OperationID.UpdateId;

          let result = await LeadSourceService.update(isForm.value);
          let msg = result["ErrorInfo"].ErrorCode;
          if (result["result"] == "Already" && msg == null) {
            loading.value = false;
            alreadyExistPop.value = true;
          } else if (msg == null) {
            emit("loaderhide");
            updatePop.value = true;
          }
        } else {
          isForm.value.EntityOperationId = props.OperationID.CreateId;

          let result = await LeadSourceService.create(isForm.value);
          let msg = result["ErrorInfo"].ErrorCode;
          if (result["result"] == "Already" && msg == null) {
            emit("loaderhide");
            alreadyExistPop.value = true;
          } else if (msg == null) {
            emit("loaderhide");
            successPop.value = true;
          }
        }
      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    });
    //findone function
    const IsEdit = async () => {
      debugger;
      loading.value = true;
      showDialog.value = true;
      try {
        label.value = "Update";
        debugger;
        const response = await LeadSourceService.getById(model.value.Id);
        let data = response["result"];
        Object.keys(isForm.value).forEach((key) => {
          if (data[key]) isForm.value[key] = data[key];
        });
        loading.value = false;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    async function GetCode() {
      // alert(JSON.stringify(Entitydata.value.EntityId))
      // alert('Entity')

      debugger;
      let data = {
        EntityId: Entitydata.value.EntityId,
        HospitalId: localstoragedata.value.OrganizationId,
        BranchId: localstoragedata.value.BranchId,
      };
      let result: any = await commonService.getCodeTemplate(data);
      debugger;
      console.log(result);
      isForm.value.Code = result;
    }

    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    const IsClear = () => {
      isForm.value.Id = 0;
      isForm.value.Name = "";
      isForm.value.Description = "";
      emit("update:selectedItem", undefined);
      emit("close");
      emit("load");
    };
    //popup create
    async function IsEditpop() {
      Editmodel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      IsClear();
      emit("load");
      successPop.value = false;
      updatePop.value = false;
      showDialog.value = false;
    }
    useHotkey({
      "ctrl+s": () => {
        IsSubmit();
      },
      "ctrl+u": () => {
        IsSubmit();
      },
      esc: () => {
        closetrigger();
      },
      enter: {
        keydown() {
          alert("test");
        },
      },
    });
    function alreadyclosetrigger() {
      debugger;
      alreadyExistPop.value = false;
    }
    return {
      IsEditpop,
      closetrigger,
      Editmodel,
      updatePop,
      successPop,
      showDialog,
      IsCreate,
      IsClear,
      IsEdit,
      isForm,
      IsSubmit,
      label,
      loading,
      alreadyExistPop,
      alreadyclosetrigger,
      $t: t,
    };
  },
});
</script>
